module.exports = __webpack_public_path__ + "img/BMMB0341.70140fcb.png";